/**
 * Address form state types
 */

export type ResidenceType = 'rent' | 'own' | 'family' | null

export interface AddressFormState {
  // Resident Address ID from API (for previous_address updates - omit for new addresses to avoid duplicates)
  ra_id?: number | null

  // Basic address fields
  address: string
  streetNumber: string
  streetName: string
  streetType: string
  aptUnit: string
  city: string
  state: string
  zipCode: string
  country: string
  outsideUS: boolean

  // Residence type
  residenceType: ResidenceType

  // Rent fields
  stillHereRent: boolean
  moveInDateRent: string
  leaseEndDate: string
  landlordName: string
  landlordEmail: string
  landlordMobile: string
  rentAmount: string
  monthsPaidRent: string

  // Own fields
  stillHereOwn: boolean
  moveInDateOwn: string
  plannedMoveOutDate: string
  monthlyMortgagePayment: string
  monthsResided: string

  // Family fields
  stillHereFamily: boolean
  moveInDateFamily: string
  plannedMoveOutDateFamily: string
  contactName: string
  contactEmail: string
  contactMobile: string
  contactWebsite: string
  contactRelationship: string
  rentAmountFamily: string
}

export interface AddressFormActions {
  setAddress: (value: string) => void
  setStreetNumber: (value: string) => void
  setStreetName: (value: string) => void
  setStreetType: (value: string) => void
  setAptUnit: (value: string) => void
  setCity: (value: string) => void
  setState: (value: string) => void
  setZipCode: (value: string) => void
  setCountry: (value: string) => void
  setOutsideUS: (value: boolean) => void
  setResidenceType: (value: ResidenceType) => void
  setStillHereRent: (value: boolean) => void
  setMoveInDateRent: (value: string) => void
  setLeaseEndDate: (value: string) => void
  setLandlordName: (value: string) => void
  setLandlordEmail: (value: string) => void
  setLandlordMobile: (value: string) => void
  setRentAmount: (value: string) => void
  setMonthsPaidRent: (value: string) => void
  setStillHereOwn: (value: boolean) => void
  setMoveInDateOwn: (value: string) => void
  setPlannedMoveOutDate: (value: string) => void
  setMonthlyMortgagePayment: (value: string) => void
  setStillHereFamily: (value: boolean) => void
  setMoveInDateFamily: (value: string) => void
  setPlannedMoveOutDateFamily: (value: string) => void
  setContactName: (value: string) => void
  setContactEmail: (value: string) => void
  setContactMobile: (value: string) => void
  setContactWebsite: (value: string) => void
  setContactRelationship: (value: string) => void
  setRentAmountFamily: (value: string) => void
  setMonthsResided: (value: string) => void
}

export const createInitialAddressState = (): AddressFormState => ({
  address: '',
  streetNumber: '',
  streetName: '',
  streetType: '',
  aptUnit: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
  outsideUS: false,
  residenceType: null,
  stillHereRent: true,
  moveInDateRent: '',
  leaseEndDate: '',
  landlordName: '',
  landlordEmail: '',
  landlordMobile: '',
  rentAmount: '',
  monthsPaidRent: '',
  stillHereOwn: true,
  moveInDateOwn: '',
  plannedMoveOutDate: '',
  monthlyMortgagePayment: '',
  monthsResided: '',
  stillHereFamily: false,
  moveInDateFamily: '',
  plannedMoveOutDateFamily: '',
  contactName: '',
  contactEmail: '',
  contactMobile: '',
  contactWebsite: '',
  contactRelationship: '',
  rentAmountFamily: '',
})

